import { Component, Input, ElementRef, OnInit } from "@angular/core";

@Component({
    selector: "[xo-table-data-date]",
    templateUrl: "./table-data-date.html"
})
export class TableDataDate implements OnInit {
    @Input() object;
    @Input() fieldName: string;

    constructor(private elRef: ElementRef){}
    
    ngOnInit(){
        this.elRef.nativeElement.classList.add(this.fieldName);
    }
}